import { useGetHeaderAndMenu } from 'app/utils/services/homePageService';

import { findSidebarItemTitle, SidebarMenuItem } from './menu';

/**
 * Sidebar link label for a menu item id (e.g. `payment_acc2acc`). Reads the
 * cached `get_header_menu` response, so pages can title themselves with the
 * exact link the user clicked. Undefined until the menu loads, or when the
 * menu has no item with that id — callers fall back to their own title.
 */
const useSidebarItemTitle = (id: string | null | undefined): string | undefined => {
  const { dataHeaderAndMenu } = useGetHeaderAndMenu();
  // get_header_menu returns the sidebar under `menu`; older payloads use `main_menu`.
  const menu: SidebarMenuItem[] | undefined =
    dataHeaderAndMenu?.menu ?? dataHeaderAndMenu?.main_menu;

  return findSidebarItemTitle(menu, id);
};

export default useSidebarItemTitle;
